import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  state: {
    readNotifications: [],
    unreadNotifications: [],
    allNotifications: [],
    idUnfixNews: '',
    idFixNews: {},
  },
  mutations,
  actions,
  getters,
}
